import PropTypes from 'prop-types'
import styled, { theme, prop } from '@nobia/zeus-components/lib/styled'
import ImageUi from '../image/Image'
import React from 'react'

const Button = styled.button`
  background-color: ${theme('colors.white')};
  min-width: 300px;
  min-height: 300px;
  width: 300px;
  border-radius: 6px;
  margin: 10px;
  padding: 25px 20px;
  scroll-snap-align: center;
  transition: opacity 150ms ease;
  border: 2px solid ${(p) => p.theme.card.border[p.color]};
  opacity: ${(p) => (p.selected ? 1 : 0.75)};
  display: flex;
  flex-direction: column;
  align-items: center;
  :hover {
    opacity: 1;
  }
`

const Info = styled.div`
  text-align: center;
  padding: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Description = styled.p`
  margin: 10px 0;
`

const ImageWrapper = styled.div`
  overflow: hidden;
  width: auto;
  background-color: ${theme('colors.white')};
  border-radius: 3px 3px 0 0;
`

const H4 = styled.h4`
  margin: 0;
`

const Price = styled.strong`
  font-family: ${prop('theme.font.paragraph.fontFamily')};
  font-weight: 500;
  font-size: 16px;
  margin-top: 20px;
  color: ${theme('colors.primary')};
`

const Image = styled(ImageUi)`
  width: auto;
  height: 100px;
`

const CabinetCard = ({ card, priceText, selected, onSelect }) => {
  const color = selected ? 'selected' : 'default'
  const { title, description, imageSrc } = card || {}

  return (
    <Button color={color} onClick={() => onSelect(card, true)}>
      <Info>
        <H4>{title}</H4>
        <Description>{description}</Description>
      </Info>
      {imageSrc && (
        <ImageWrapper>
          <Image publicId={imageSrc} width={100} height={100} />
        </ImageWrapper>
      )}
      {priceText && <Price>{priceText}</Price>}
    </Button>
  )
}

CabinetCard.defaultProps = {
  card: null,
  priceText: null,
}

CabinetCard.propTypes = {
  card: PropTypes.shape({}),
  priceText: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default CabinetCard
